var caseStudyTabComponent = (function () {
  var csTabsWrapper = document.querySelector(".cs-tabs-wrapper"),
    csComponentTabs = document.querySelectorAll(
      '.cs-tabs-panel__list-item[role="tab"]'
    ),
    csContentPanel = document.querySelectorAll(
      '.cs-tabs-content__main[role="tabpanel"]'
    ),
    panelMainParent = document.querySelector(".cs-tabs-content"),
    intervalSlide,
    loadFlag = true,
    currentIndex = 0,
    isPaused = true,
    csComponentBullets = document.querySelectorAll(
      '.cs-tabs-bullets__list-item[role="button"]'
    );

  return {
    init: init,
  };

  function init() {
    if (
      csComponentTabs.length &&
      csContentPanel.length &&
      csComponentBullets.length
    ) {
      //Add min-height for all tab desc section
      var tabContentSection = document.querySelectorAll(
          ".cs-tabs-content__child-left-main"
        ),
        tabSectionMaxHeight = [],
        tabCardMaxHeight = [];
      for (var j = 0; j < tabContentSection.length; j++) {
        tabSectionMaxHeight.push(tabContentSection[j].offsetHeight);
        tabCardMaxHeight.push(
          tabContentSection[j]
            .closest(".cs-tabs-content__child")
            .querySelector(".cs-tabs-content__card-wrap").offsetHeight
        );
      }

      for (var j = 0; j < tabContentSection.length; j++) {
        tabSectionMaxHeight.push(tabContentSection[j].offsetHeight);
      }

      for (var k = 0; k < tabContentSection.length; k++) {
        tabContentSection[k].style.minHeight =
          Math.max.apply(Math, tabSectionMaxHeight) + "px"; // set max height
        tabContentSection[k]
          .closest(".cs-tabs-content__child")
          .querySelector(".cs-tabs-content__card-wrap").style.minHeight =
          Math.max.apply(Math, tabCardMaxHeight) + "px"; // set max height
      }

      window.addEventListener('scroll', activateSliderOnView); //Check slider is in viewport on scroll
      window.addEventListener('load', activateSliderOnView);  //Check slider is in viewport on load

      // For easy reference
      var keys = {
        end: 35,
        home: 36,
        left: 37,
        up: 38,
        right: 39,
        down: 40,
        delete: 46,
        enter: 13,
        space: 32,
        tab: 9
      };

      // Add or subtract depending on key pressed
      var direction = {
        37: -1,
        38: -1,
        39: 1,
        40: 1,
      };

      // Bind listeners for product component
      for (i = 0; i < csComponentTabs.length; ++i) {
        setEventsOnCsComponentTabs(i);
      }

      // Bind listeners on bullets for product component
      for (var b = 0; b < csComponentBullets.length; ++b) {
        setEventsOnCsComponentBullets(b);
      }

      function setEventsOnCsComponentBullets(index) {
        csComponentBullets[index].addEventListener(
          "click",
          setClickEvtOnCsComponentBullets
        );

        // Build an array with all tabs (<button>s) in it
        csComponentBullets[index].index = index;
      }

      // When a bullet is clicked, activateTab is fired to activate it
      function setClickEvtOnCsComponentBullets(event) {
        event.preventDefault();
        var bullet = event.target,
          bulletIndex = bullet.index,
          correspondingTab = csComponentTabs[bulletIndex];

        activateCsComponentTab(correspondingTab);
        setFocus(bullet);
        activateBullet(bullet);
      }

      function setEventsOnCsComponentTabs(index) {
        csComponentTabs[index].addEventListener(
          "click",
          setClickEvtOnCsComponentTab
        );
        csComponentTabs[index].addEventListener(
          "keydown",
          setKeydownEvtOnCsComponentTab
        );
        csComponentTabs[index].addEventListener(
          "keyup",
          setKeyupEvtOnCsComponentTab
        );

        // Build an array with all tabs (<button>s) in it
        csComponentTabs[index].index = index;
      }

      // When a tab is clicked, activateTab is fired to activate it
      function setClickEvtOnCsComponentTab(event) {
        var tab = event.target,
          tabIndex = tab.index,
          correspondingBullet = csComponentBullets[tabIndex];
        activateCsComponentTab(tab, false);
        activateBullet(correspondingBullet);
      }

      //activate corresponding bullet
      function activateBullet(bullet) {
        var activeBullet = document.querySelector(
          '.cs-tabs-bullets__list-item[aria-selected="true"]'
        );
        if (activeBullet) {
          activeBullet.setAttribute("aria-selected", "false");
        }

        bullet.setAttribute("aria-selected", "true");
        bullet.setAttribute("tabindex", "-1");
        bullet.parentElement.classList.add("cs-tabs-bullets__list--active");
      }

      // Handle keydown on Product tabs
      function setKeydownEvtOnCsComponentTab(event) {
        var key = event.keyCode;

        switch (key) {
          case keys.end:
            event.preventDefault();
            // Activate last tab
            focusCsComponentLastTab();
            break;
          case keys.home:
            event.preventDefault();
            // Activate first tab
            focusCsComponentFirstTab();
            break;
          default:
        }
      }

      // Handle keyup on Product tabs
      function setKeyupEvtOnCsComponentTab(event) {
        var key = event.keyCode;

        switch (key) {
          case keys.left:
          case keys.right:
            switchCsTabOnArrowPress(event);
            break;
          case keys.enter:
          case keys.space:
            activateCsComponentTab(event.target);
            break;
          default:
        }

        //add custom focus class
        if (keys.tab == key && csComponentTabs.length > 0) {
          if (event.target.classList.contains("cs-tabs-panel__list-item")) {
            for (var i = 0; i < csComponentTabs.length; ++i) {
              csComponentTabs[i].classList.add("focus-visible");
            } 
          }
        }
      }

      // Either focus the next, previous, first, or last tab
      // depending on key pressed
      function switchCsTabOnArrowPress(event) {
        var pressed = event.keyCode;
        if (direction[pressed]) {
          var target = event.target;
          if (target.index !== undefined) {
            if (csComponentTabs[target.index + direction[pressed]]) {
              csComponentTabs[target.index + direction[pressed]].focus();
            } else if (pressed === keys.left || pressed === keys.up) {
              focusCsComponentLastTab();
            } else if (pressed === keys.right || pressed == keys.down) {
              focusCsComponentFirstTab();
            }
          }
        }
      }

      // Activates any given tab panel
      function activateCsComponentTab(tab, setFocus) {
        //clear the product slider interval to stop it
        clearInterval(intervalSlide);

        setFocus = setFocus || false;

        // Deactivate all other tabs
        deactivateCsComponentTabs();

        // Remove tabindex attribute
        tab.removeAttribute("tabindex");

        //remove focus class custom
        tab.classList.remove("focus-visible");

        // Set the tab as selected
        tab.setAttribute("aria-selected", "true");

        //set active to parent element
        tab.parentElement.classList.add("cs-tabs-panel__list--active");

        currentIndex = parseInt(tab.getAttribute("data-tab"));

        // Get the value of aria-controls (which is an ID)
        var panelControl = tab.getAttribute("aria-controls"),
          panelControlDom = document.getElementById(panelControl),
          panelTriggerElem = panelControlDom.parentElement;

        if (panelControlDom) {
          panelControlDom.setAttribute("aria-hidden", "false");
          var offsetLeft = panelTriggerElem ? panelTriggerElem.offsetLeft : 0,
            cardsWrapperHeight = panelControlDom.offsetHeight,
            panelActiveAnchorElem = panelControlDom.querySelectorAll("a");

          for (var l = 0; l < panelActiveAnchorElem.length; l++) {
            panelActiveAnchorElem[l].removeAttribute("tabindex");
          }

          //scroll Product Panel into viewport
          setTimeout(function () {
            fnScrollElemInViewport(panelMainParent, offsetLeft, 10);
          }, 100);
        }

        // Set focus when required
        if (setFocus) {
          tab.focus();
        }

        //show images from lazy load
        lazyLoading.show();

        intervalSlide = setTimeout(activateNextTab, 14000);
      }

      function fnScrollElemInViewport(element, to, duration) {
        var start;
        start = element.scrollLeft;
        var change = to - start,
          currentTime = 0,
          increment = 5;

        var animateScrollFn = function () {
          currentTime += increment;
          var val = Math.easeInOutQuad(currentTime, start, change, duration);

          element.scrollLeft = val;
          if (currentTime < duration) {
            setTimeout(animateScrollFn, increment);
          }
        };
        animateScrollFn();
      }

      //t = current time
      //b = start value
      //c = change in value
      //d = duration
      Math.easeInOutQuad = function (t, b, c, d) {
        t /= d / 2;
        if (t < 1) return (c / 2) * t * t + b;
        t--;
        return (-c / 2) * (t * (t - 2) - 1) + b;
      };

      // Deactivate all tabs and tab panels
      function deactivateCsComponentTabs() {
        for (var j = 0; j < csComponentTabs.length; j++) {
          csComponentTabs[j].setAttribute("tabindex", "-1");
          csComponentTabs[j].setAttribute("aria-selected", "false");
          csComponentTabs[j].parentElement.classList.remove(
            "cs-tabs-panel__list--active"
          );
        }

        setTimeout(function () {
          for (var k = 0; k < csContentPanel.length; k++) {
            csContentPanel[k].setAttribute("aria-hidden", "true");
            var panelAnchorElem = csContentPanel[k].querySelectorAll("a");
            for (var l = 0; l < panelAnchorElem.length; l++) {
              panelAnchorElem[l].setAttribute("tabindex", "-1");
            }
          }
        }, 100);

        for (var l = 0; l < csComponentTabs.length; l++) {
          csComponentBullets[l].removeAttribute("tabindex", "-1");
          csComponentBullets[l].setAttribute("aria-selected", "false");
          csComponentBullets[l].parentElement.classList.remove(
            "cs-tabs-bullets__list--active"
          );
        }
      }

      // Make a guess
      function focusCsComponentFirstTab() {
        csComponentTabs[0].focus();
      }

      // Make a guess
      function focusCsComponentLastTab() {
        csComponentTabs[csComponentTabs.length - 1].focus();
      }

      // Function to activate the next tab after a delay
      function activateNextTab() {
        currentIndex = (currentIndex + 1) % csComponentTabs.length; // Cycle through tabs
        currentIndex = loadFlag ? 0 : currentIndex;
        var nextTab = csComponentTabs[currentIndex];
        activateCsComponentTab(nextTab); // Activate the next tab
        var correspondingBullet = csComponentBullets[currentIndex];
        activateBullet(correspondingBullet); // Activate the corresponding bullet
        loadFlag = false;
      }

      function isInViewport(element) {
        var rect = element.getBoundingClientRect();
        return (
          rect.top < (window.innerHeight - 63) && 
          rect.bottom > 63 &&
          rect.left < window.innerWidth &&
          rect.right > 0
        );
      }
          
      function activateSliderOnView() {
        if (isInViewport(panelMainParent) && isPaused) {
          isPaused = false;
          // Start the automatic activation
          activateNextTab();
        }
      }
    }
  }
})();

caseStudyTabComponent.init();
